export default {
  export: {
    excel: "Exportar Excel",
    csv: "CSV",
    busy: "Exportando…",
    error: "No se pudo exportar",
    orgTitle: "Exportar todos los datos de la organización",
    orgIntro: "Un ZIP con un CSV y un JSON por entidad: productos y competidores (con reglas e importaciones paralelas), cuentas y sus avisos, severidades, alertas críticas y textos que hayáis cambiado, los eventos con sus marcas, las candidatas con su resolución, las plantillas de informe y los avisos enviados.",
    orgButton: "Descargar ZIP",
  },
};
